module.exports = "/static/assets/ad64af1465b1d5d22d82e5d17a2a7b49.png";